/*****************************
スクロールでエリアに入るとクラスを付与

target : 検知対象となる class / id
config : {
	class:{
		// 画面内に入ったら付与
		'in' : 'inView_in',
		// 画面の外に出たら付与
		'out' : 'inView_out'
	}
	// 画面に入った判定の距離。0にすると画面端で判定
	// 必ずin_rangeより小さい値にする
	in_range : 50,
	// 画面から出た判定の距離
	out_range: 0,
	//表示エリアの中だけピンをたてる。上にスクロールするとまた表示
	is_inView_only: false
}


*/
var CaracolScrollInView;

module.exports = CaracolScrollInView = function( target, config ){
	'use strict';

	var defaults = {
		class:{
			in : 'inView_in',
			out : 'inView_out'
		},
		in_range : 50,
		out_range: 40,  // 画面外判定。
		margin_bottom: 50,  // 最下部の許容値
		is_inView_only: false

	};
	this.opt = $.extend( defaults, config );
	this.target = target;
	this.$target = $(target);
	this.is_started = false;
	this.is_ended = false;  // 全部表示した
	this.$window =$(window);
	this.win_height = null;
	this.doc_height = null;

	this.ev_check_element = null;

	this.DATA_TOP = 'ccl-inView-top';
	this.DATA_BOTTOM = 'ccl-inView-bottom';

};

/********************
* スクロール検知処理を開始
*/
CaracolScrollInView.prototype.start = function(){
	'use strict';
	// すでに開始していたら無視
	if( this.is_started ) return;

	// 各アイテムの高さをチェック
	this.check_element();
	this.ev_check_element = setInterval( $.proxy( this.check_element, this ), 2000 );

	// リサイズイベントでドキュメント高さチェック
	this.resize();
	var ev_resize = $.throttle( 100, $.proxy( this.resize, this ));
	this.$window.on( 'resize', ev_resize );

	// スクロールイベント
	this.scroll();
	var ev_scroll = $.throttle( 100, $.proxy( this.scroll, this));
	this.$window.on( 'scroll', ev_scroll );

	this.is_started = true;
};

/********************
* 検知処理を終了
*/
CaracolScrollInView.prototype.stop = function(){
	'use strict';
	clearInterval( this.ev_check_element )
	this.$window.off( 'resize', this.resize );
	this.$window.off( 'scroll', this.scroll );
}

/********************
* 対象エレメントの座標と高さをチェック
*/
CaracolScrollInView.prototype.check_element = function(){
	'use strict';
	var DATA_TOP = this.DATA_TOP;
	var DATA_BOTTOM = this.DATA_BOTTOM;

	this.$target.each( function(){
		var $elm = $(this);
		var top = $elm.offset().top;
		var bottom = top + $elm.height();
		$elm.data( DATA_TOP, top );
		$elm.data( DATA_BOTTOM, bottom );
	});
}

/********************
* スクロール処理
*/
CaracolScrollInView.prototype.scroll = function(){
	'use strict';

	var self = this;
	var $window = this.$window;
	var $target = this.$target;
	var opt = this.opt;

	// スクロール上位置と下位置
	var scroll_top = $window.scrollTop();
	var scroll_bottom = scroll_top + this.win_height;

	// 対象エレメントを順にチェック
	$target.each( function(){

		// エレメントの上辺・下辺を取得
		var $elm = $(this);
		var top = $elm.data( self.DATA_TOP );
		var bottom = $elm.data( self.DATA_BOTTOM );


		// エリア内限定の設定ではなく、
		// すでに完了クラスが付与されていたら無視
		if( !opt.is_inView_only && $elm.hasClass(opt.class.in) ) return true;

		if( !opt.is_inView_only ){
			// 画面内判定：表示エリアより上は全部ピン立てる
			if( scroll_bottom - opt.in_range > top  ){
				$elm.addClass( opt.class.in );
			}
		}else{
			// 表示エリア内だけ
			if( self.is_inView( top, bottom, scroll_top, scroll_bottom )){
				$elm.removeClass( opt.class.out );
				$elm.addClass( opt.class.in );
			}else if( $elm.hasClass( opt.class.in ) && self.is_outView( top, bottom, scroll_top, scroll_bottom ) ){
				$elm.removeClass( opt.class.out );
				$elm.addClass( opt.class.out );
			}
		}
	});

	// エリア内限定でないなら、一番下までスクロールしたら停止
	if( !opt.is_inView_only ){
		if( scroll_bottom >= this.doc_height - opt.margin_bottom ){
			self.stop();
		}
	}
};

/********************
* エリア内にエレメントが見えているか
* element top / element bttom / scroll top / scroll bottom
*/
CaracolScrollInView.prototype.is_inView = function( et, eb, st, sb ){
	'use strict';
	var ir = this.opt.in_range;
	// 上辺が画面内 || 下辺が画面内
	if( st + ir < et && et < sb - ir || st + ir < eb && eb < sb - ir ) return true;
	return false;
}

/********************
* エリア外に移動したか
* element top / element bttom / scroll top / scroll bottom
*/
CaracolScrollInView.prototype.is_outView = function( et, eb, st, sb ){
	'use strict';
	var or = this.opt.out_range;
	// 下辺が画面外 || 上辺が画面外
	if( eb < st + or || sb - or < et ) return true;
	return false;
}


/********************
* ウィンドウをリサイズしたら高さなどをチェック
*/
CaracolScrollInView.prototype.resize = function(){
	'use strict';
	this.win_height = this.$window.height();
	this.doc_height = $(document).height();
}




//////////////////
// WEBPACK FOOTER
// /Users/dada/www/_caracol_works/javascript/for_webpack/caracol/caracol2.0.0/effect/scroll_in_view.js
// module id = 15
// module chunks = 0